/**
 * Bloqueia o acesso direto pela URL a páginas com regras de acesso.
 *
 * As regras são declaradas na página com `definePageMeta({ navigationGuardConditions })`,
 * usando as mesmas condições que escondem os itens do menu (`useNavigationGuard`).
 * Corre depois do `auth.global` (ordem alfabética), com o utilizador já autenticado.
 *
 * @param to - A rota de destino.
 * @returns Redireciona para o dashboard da organização quando o acesso não é permitido.
 */
export default defineNuxtRouteMiddleware((to) => {
  // * Plano e permissões vêm do localStorage (auth store): só existem no cliente
  if (import.meta.server) return

  const conditions = to.meta.navigationGuardConditions
  if (!conditions) return

  const { checkNavigationAccess } = useNavigationGuard()
  if (checkNavigationAccess(conditions)) return

  const { organizationId } = to.params
  if (!organizationId) return navigateTo({ name: 'select-organization' })

  return navigateTo({
    name: 'organizationId-dashboard',
    params: { organizationId },
  })
})
